import { CandidateMilitaryServiceStatus } from '@flex-apis/recruiting';
import type { SelectProps } from '@flex-design-system/fx';
import { Select } from '@flex-design-system/fx';
import { Translation } from '@flex-packages/i18n';

import {
  isCandidateMilitaryServiceStatus,
  MILITARY_SERVICE_CONTENT,
} from '../../base';

interface MilitaryServiceSelectProps extends SelectProps {
  militaryService?: CandidateMilitaryServiceStatus;
  onMilitaryServiceChange: (
    newMilitaryService: CandidateMilitaryServiceStatus
  ) => void;
}

const MILITARY_SERVICES: Array<CandidateMilitaryServiceStatus> = [
  CandidateMilitaryServiceStatus.Exempted,
  CandidateMilitaryServiceStatus.ExpirationTermOfService,
  CandidateMilitaryServiceStatus.InProgressTermOfService,
  CandidateMilitaryServiceStatus.Unfulfilled,
];

function MilitaryServiceSelect({
  children,
  militaryService,
  onMilitaryServiceChange,
  ...props
}: MilitaryServiceSelectProps) {
  return (
    <Select
      {...props}
      value={militaryService}
      onValueChange={value => {
        if (!isCandidateMilitaryServiceStatus(value)) {
          return;
        }
        onMilitaryServiceChange(value);
      }}
    >
      <Select.Trigger asChild>{children}</Select.Trigger>
      <Select.Content onCloseAutoFocus={e => e.preventDefault()}>
        {MILITARY_SERVICES.map(service => (
          <Select.Option key={service} value={service}>
            <Select.OptionTitle>
              <Translation tKey={MILITARY_SERVICE_CONTENT[service].i18n} />
            </Select.OptionTitle>
          </Select.Option>
        ))}
      </Select.Content>
    </Select>
  );
}

export default MilitaryServiceSelect;
